<template>
  <div>
    <Head :title="`${$t('treatments.treatment')} #${data.id}`"/>
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-gray-400 hover:text-gray-600" :href="`/applicants/${data.applicant_details.id}/view`">
        {{ data.applicant_details.name }}
      </Link>
      <span class="text-gray-400 font-medium">/ </span>
      <Link class="text-gray-400 hover:text-gray-600"
            :href="`/applicants/${data.applicant_id}/treatments/${data.id}/view`">
        {{ data.treatment_type_name }}
      </Link>
      <span class="text-gray-400 font-medium">/ </span>
      {{ $t('global.update') }}
    </h1>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <quill-input
            v-model="form.note" :error="form.errors.note" class="pb-8 pr-6 w-full lg:w-2/2"
            :label="$t('note')"
          />
        </div>
        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">
            {{ $t('global.update') }}
          </loading-button>
        </div>

      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import QuillInput from '@/Shared/QuillInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    Head,
    Link,
    QuillInput,
    LoadingButton,
  },
  layout: Layout,
  props: {
    data: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        note: this.data.note,
      }),
    }
  },
  methods: {
    update() {
      this.form.put(`/applicants/${this.data.applicant_id}/treatments/${this.data.id}/note`)
    },
  },
}
</script>
